<template>
  <div class="eventContent">
    <div>
      <div class="editorTitle">
        活動內容
        <confirmBtns :style="{marginLeft: '30px', alignSelf: 'center', marginRight: '23px'}"
        @confirm="save" @cancel="cancel"/>
      </div>
      <div>
        <quillEditor :options="editorOption" v-model="textContent"/>
      </div>
    </div>
    <div>
      <div>
        <div class="phone">
          <h1 :style="{textAlign: 'start'}">成美周晬禮讚</h1>
          <div v-html="textContent"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getapi, postapi } from '../../store/fetch'
import confirmBtns from '../../components/confirmBtns.vue'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
export default {
  components: {
    // draggable,
    // inputField,
    // inputField2,
    confirmBtns,
    quillEditor
  },
  data () {
    return {
      textContent: null,
      editorOption: {
        theme: 'snow',
        placeholder: '請在此編輯活動內容'
      },
      name: null,
      field_option_1: null,
      field_option_2: null,
      field_option_3: null,
      session: null
    }
  },
  async mounted () {
    this.textContent = await getapi('selections/babyContent')
    if (this.textContent === false) {
      await postapi('selections/babyContent', { key: 'value', data: null })
      this.textContent = await getapi('selections/babyContent')
    }
  },
  methods: {
    cancel () {},
    async save () {
      const r = await postapi('selections/babyContent', {
        key: 'value',
        data: this.textContent
      })
      if (r) {
        this.textContent = r
      }
    }
  }
}
</script>
<style lang="scss">
.eventContent {
  * {
    font-family: inherit;
  }
strong {
  font-weight: 700;
}
em {
  font-style: italic;
}
.quill-editor {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.ql-toolbar.ql-snow + .ql-container.ql-snow {
  flex: 1;
  // overflow-y: auto;
  // height: calc(100vh - 210px);
  height: fit-content;
}
.ql-editor {
  overflow-y: auto;
  &::-webkit-scrollbar {
    height: 5px;
    width: 5px;
    background-color: #F5F5F5;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 20px;
    box-shadow: inset 0 0 6px #0000004d;
    background-color: var(--blue-100);
  }
  &::-webkit-scrollbar-track {
    border: none;
    border-radius: 20px;
    background-color: #d8d8d8;
    border: 2px solid #FFFFFF!important;
  }
  p {
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 162%;
    color: var(--color-letter);
  }
  h1 {
    font-style: normal;
    font-weight: 500;
    font-size: 32px;
    line-height: 162%;
    color: var(--color-checked);
    text-align: start;
  }
  h2 {
    font-style: normal;
    font-weight: 500;
    font-size: 28px;
    line-height: 162%;
    color: var(--color-checked);
  }
  .ql-size-small {
    font-size: small;
  }
  .ql-size-large {
    font-size: larger;
  }
  .ql-size-huge {
    font-size: xx-large;
  }
}
.phone {
  font-family: 'Noto Sans TC';
  * {
    font-family: inherit;
  }
  .ql-font-serif {
    font-family: serif;
  }
  .ql-font-monospace {
    font-family: 'Space Mono';
  }
  img {
    max-width: 100%;
    max-height: 100%;
  }
  p {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 162%;
    color: var(--color-letter);
    text-align: start;
    &.ql-align-center {
      text-align: center;
    }
    &.ql-align-right {
      text-align: right;
    }
    &.ql-align-justify {
      text-align: justify;
    }
    &.ql-indent-1 {
      text-indent: 2em;
    }
    &.ql-indent-2 {
      text-indent: 4em;
    }
    &.ql-indent-3 {
      text-indent: 6em;
    }
  }
  h1 {
    font-style: normal;
    font-weight: 500;
    font-size: 28px;
    line-height: 162%;
    color: var(--color-checked);
  }
  h2 {
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 162%;
    color: var(--color-checked);
  }
  .ql-size-small {
    font-size: small;
  }
  .ql-size-large {
    font-size: larger;
  }
  .ql-size-huge {
    font-size: xx-large;
  }
}
}
</style>
<style lang="scss" scoped>
.editorTitle {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 25px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
}
.eventContent {
  width: 100%;
  height: calc(100vh - 90px);
  position: relative;
  display: grid;
  grid-template-columns: 1fr 499px;
  &>div:nth-child(1) {
    border-right: 1px solid var(--color-border);
    padding: 24px 43px;
    display: grid;
    grid-template-rows: 40px 1fr;
    gap: 20px;
    height: calc(100vh - 90px);
    box-sizing: border-box;
    overflow-y: auto;
    &>div:nth-child(2) {
      height: calc(100% - 100px);
    }
  }
  &>div:nth-child(2)>div {
    margin-top: 1px;
    margin-left: 2px;
    width: 467px;
    border: 1px solid var(--color-border);
    min-height: calc(100vh - 92px);
    max-height: calc(100vh - 92px);
    overflow-y: auto;
    &>div {
      padding: 30px 44px;
    }
    &::before {
      position: sticky;
      top: 0;
      display: inline-flex;
      content: '手機呈現預覽';
      height: 50px;
      background-color: var(--color-infobox);
      color: var(--color-checked);
      width: 100%;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-family: 'Noto Sans TC';
      font-style: normal;
      font-weight: 400;
    }

  }
}
.header {
  height: 89px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  letter-spacing: 0.15em;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-pri);
  gap: 20px;
  &>div:nth-child(1) {
    display: flex;
    align-items: center;
    &::before {
      content: '';
      display: inline-flex;
      width: 55px;
      height: 55px;
      mask-image: url(/setting.svg);
      background-color: var(--color-pri);
      mask-position: center;
      mask-repeat: no-repeat;
      margin-inline: 10px;
    }
  }
  span {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }
}
</style>
